import angular from 'angular';
import wegbewijzeringComponent from './wegbewijzering.component';

let wegbewijzeringModule = angular.module('wegbewijzering', [])

.component('wegbewijzering', wegbewijzeringComponent)

.name;

export default wegbewijzeringModule;



// WEBPACK FOOTER //
// ./client/app/components/content-types/wegbewijzering/wegbewijzering.js